import _taggedTemplateLiteral from "/codebuild/output/src997666004/src/github.com/EverlyWell/www/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  position: absolute;\n  left: 0;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  flex-direction: row;\n  position: relative;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  width: 100%;\n  justify-content: center;\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from "styled-components";
import { colors } from "../../../shared/constants";
import { Chip } from "../Chip";
var ChipContainer = styled.div(_templateObject(), function (t) {
  return t.isReverse ? "transform: scaleX(-1)" : null;
}),
    ChipWrapper = styled.div(_templateObject2()),
    ActiveChip = styled(Chip)(_templateObject3(), colors.teal3);
export { ChipContainer, ChipWrapper, ActiveChip };